/* Favorite analytics: product actions only; no saved-list replay or customer data.
   Disabled until the RO GA4 measurement ID has been verified. */
(() => {
  if (window.__feFavTracking) return;
  let config;
  try { config = JSON.parse(document.getElementById('fe-fav-tracking-config').textContent); } catch (_) { return; }
  if (!config.enabled || !/^G-[A-Z0-9]+$/.test(config.measurementId || '')) return;
  if (!['femieko.ro', 'www.femieko.ro'].includes(window.location.hostname)) return;
  window.__feFavTracking = true;

  const allowed = () => {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') {
    try { window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], () => {}); }
    catch (_) { /* Unknown consent means no measurement. */ }
  }

  let destinationConfigured = false;
  const send = (name, payload) => {
    if (!allowed()) return;
    if (config.dryRun) {
      document.dispatchEvent(new CustomEvent('fe-fav:analytics-preview', { detail: { name, payload } }));
      return;
    }
    if (typeof window.gtag !== 'function') return;
    if (!destinationConfigured) {
      window.gtag('config', config.measurementId, { send_page_view: false });
      destinationConfigured = true;
    }
    window.gtag('event', name, { ...payload, send_to: config.measurementId,
      ...(config.debug ? { debug_mode: true } : {}) });
  };

  document.addEventListener('fe-fav:change', async (event) => {
    const action = event.detail || {};
    if (action.persisted !== true || typeof action.on !== 'boolean' || !allowed()) return;
    const id = String(action.id || '');
    const handle = String(action.handle || '');
    if (!/^\d+$/.test(id) || !/^[a-zA-Z0-9-]+$/.test(handle)) return;
    const currency = window.Shopify?.currency?.active;
    if (!/^[A-Z]{3}$/.test(currency || '')) return;
    const item = { item_id: id, quantity: 1 };
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        signal: AbortSignal.timeout(4000)
      });
      if (response.ok) {
        const product = await response.json();
        if (String(product.id) === id) {
          item.item_name = product.title;
          item.item_brand = product.vendor;
          if (typeof product.price === 'number' && product.price >= 0) item.price = product.price / 100;
        }
      }
    } catch (_) { /* Keep the product ID count when product enrichment is unavailable. */ }
    const payload = { currency, items: [item], wishlist_product_id: id,
      wishlist_product: String(item.item_name || handle).slice(0, 100) };
    if (typeof item.price === 'number') payload.value = item.price;
    // Consent can be withdrawn while the product request is pending.
    send(action.on ? 'add_to_wishlist' : 'remove_from_wishlist', payload);
  });
})();
